export function buildTaskTitleFromNotes(notes, { maxLength = 240 } = {}) {
  const raw = String(notes ?? "").trim();
  if (!raw) return "";

  const firstNonEmptyLine =
    raw
      .split(/\r?\n/)
      .map((line) => line.trim())
      .find(Boolean) || "";

  const compact = (firstNonEmptyLine || raw).replace(/\s+/g, " ").trim();
  if (!compact) return "";

  const safeMax = Number.isFinite(Number(maxLength)) ? Math.max(1, Number(maxLength)) : 240;
  if (compact.length <= safeMax) return compact;
  return compact.slice(0, safeMax);
}

